import { DatasourceSearchMethod } from './types';
export var mapSearchMethod = function mapSearchMethod(searchMethod) {
  switch (searchMethod) {
    case 'basic':
      return DatasourceSearchMethod.DATASOURCE_BASIC_FILTER;
    case 'jql':
      return DatasourceSearchMethod.DATASOURCE_SEARCH_QUERY;
    default:
      return null;
  }
};